module.exports = __webpack_public_path__ + "img/partner_48.93849c30.png";